import { AxiosResponse } from 'axios';
import { api } from './config';

export interface TrafficSign {
  latitude: number;
  longitude: number;
  signType: string;
  speedLimit?: number;
  distanceFromRoute?: number;
  category?: number;  // Raw category value (0x04 = zone boundary, 0x05 = road features)
}

export interface TrafficSignStatus {
  isAvailable: boolean;
}

export interface TrafficSignRoutePoint {
  lat: number;
  lng: number;
}

export interface BoundingBox {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
}

export const trafficSignApi = {
  /**
   * Check if traffic sign service is available
   */
  getStatus: (): Promise<AxiosResponse<TrafficSignStatus>> =>
    api.get('/trafficsign/status'),

  /**
   * Get traffic signs near a point
   */
  getSignsNearPoint: (
    lat: number,
    lng: number,
    radius: number = 500
  ): Promise<AxiosResponse<TrafficSign[]>> =>
    api.get('/trafficsign/near', { params: { lat, lng, radius } }),

  /**
   * Get traffic signs along a route
   */
  getSignsAlongRoute: (
    routePoints: TrafficSignRoutePoint[],
    buffer: number = 100
  ): Promise<AxiosResponse<TrafficSign[]>> =>
    api.post('/trafficsign/along-route', { routePoints }, { params: { buffer } }),

  /**
   * Get urban boundary signs (StartUrban and EndUrban) within a bounding box
   * Note: Bounding box is required and limited to ~50km x 50km
   */
  getUrbanBoundarySigns: (bbox: BoundingBox): Promise<AxiosResponse<TrafficSign[]>> =>
    api.get('/trafficsign/urban-boundaries', {
      params: {
        minLat: bbox.minLat,
        maxLat: bbox.maxLat,
        minLng: bbox.minLng,
        maxLng: bbox.maxLng,
      },
    }),
};
